// extracted by mini-css-extract-plugin
export var attribution = "_b7-4";
export var authorName = "_b7-5";
export var quote = "_b7-3";
export var testimonial = "_b7-2";
export var trustedBy = "_b7-0";
export var trustedByLabel = "_b7-1";